<template>
  <section>
    <q-tabs
      v-model="tab"
      dense
      class="text-grey bg-grey-3 q-mt-xl"
      active-color="primary"
      indicator-color="primary"
      align="justify"
      narrow-indicator
    >
      <q-tab name="grupos" label="Grupos Associados" />
      <q-tab name="treinamentos" label="Treinamentos Associados" />
      <q-tab name="ferramentas" label="Ferramentas Associadas" />
      <q-tab name="participação" label="Participação em Treinamentos" />
    </q-tabs>
    <q-tab-panels v-model="tab" animated>
      <q-tab-panel name="grupos">
        <table-grupos />
      </q-tab-panel>
      <q-tab-panel name="treinamentos">
        <table-treinamentos />
      </q-tab-panel>
      <q-tab-panel name="ferramentas">
        <table-ferramentas />
      </q-tab-panel>
      <q-tab-panel name="participação">
        <table-participacao />
      </q-tab-panel>
    </q-tab-panels>
  </section>
</template>

<script>
import { ref } from "vue";
import TableFerramentas from "./TableFerramentas.vue";
import TableGrupos from "./TableGrupos.vue";

import TableTreinamentos from "./TableTreinamentos.vue";
import TableParticipacao from "./TableParticipacao.vue";
export default {
  components: {
    TableGrupos,
    TableTreinamentos,
    TableFerramentas,
    TableParticipacao,
  },
  setup() {
    const tab = ref("grupos");
    return {
      tab,
    };
  },
};
</script>
